import { FinancialAccount, FinancialAccountInput, FinancialAccountsResponse } from "@/schema/financial-account"

import { ApiContext, apiContextFetch } from "../base"
import { signedIdsForUploadedFiles } from "../direct-upload-files"

export async function fetchHouseholdFinancialAccounts(
  context: ApiContext,
  householdId: string
): Promise<FinancialAccountsResponse> {
  return apiContextFetch(context, `clients/${householdId}/financial_accounts`)
}

export async function fetchFinancialAccount(
  context: ApiContext,
  householdId: string,
  accountId: string
): Promise<FinancialAccount> {
  return apiContextFetch(context, `clients/${householdId}/financial_accounts/${accountId}`)
}

export async function createFinancialAccount(
  context: ApiContext,
  householdId: string,
  input: FinancialAccountInput,
  newFiles: File[] = []
): Promise<FinancialAccount> {
  const files = newFiles.length ? await signedIdsForUploadedFiles(context, newFiles) : undefined

  return apiContextFetch(context, `clients/${householdId}/financial_accounts`, {
    method: "POST",
    body: JSON.stringify({ financial_account: { ...input, ...(files ? { files } : {}) } }),
  })
}

export async function updateFinancialAccount(
  context: ApiContext,
  householdId: string,
  accountId: string,
  input: Partial<FinancialAccountInput>
): Promise<FinancialAccount> {
  return apiContextFetch(context, `clients/${householdId}/financial_accounts/${accountId}`, {
    method: "PUT",
    body: JSON.stringify({ financial_account: input }),
  })
}

export async function updateFinancialAccountWithFiles(
  context: ApiContext,
  householdId: string,
  accountId: string,
  newFiles: File[],
  existingSignedIds: string[] = []
): Promise<FinancialAccount> {
  const files = await signedIdsForUploadedFiles(context, newFiles, existingSignedIds)

  return apiContextFetch(context, `clients/${householdId}/financial_accounts/${accountId}`, {
    method: "PUT",
    body: JSON.stringify({ financial_account: { files } }),
  })
}

export async function deleteFinancialAccount(
  context: ApiContext,
  householdId: string,
  accountId: string
): Promise<void> {
  return apiContextFetch(context, `clients/${householdId}/financial_accounts/${accountId}`, {
    method: "DELETE",
  })
}

export async function affiliateFinancialAccount(
  context: ApiContext,
  householdId: string,
  accountId: string
): Promise<FinancialAccount> {
  return apiContextFetch(context, `clients/${householdId}/financial_accounts/affiliate`, {
    method: "POST",
    body: JSON.stringify({ financial_account_id: accountId }),
  })
}
